import React from 'react';
import PropTypes from 'prop-types';
import styles from './blur.less';

const Blur = ({ children }) => (
  <div className={styles.container}>
    <div className={styles.content}>{children}</div>
  </div>
);

Blur.propTypes = {
  children: PropTypes.node,
};

Blur.defaultProps = {
  children: null,
};

export default Blur;
